// Função para retornar URLs de acordo com o ambiente
// Exemplo de uso: getBaseUrl('API_MAIN')

export enum EBff {
	EP = "EP",
	FGTS = "FGTS",
}

const urlsBFF = {
	[EBff.EP]: {
		development: "/api",
		production: "/api",
	},
	[EBff.FGTS]: {
		development: "/bff",
		production: "/bff",
	},
};

export const getUrlBFF = (bff: EBff) => {
	const host = window.location.host;

	const environment =
		window.location.host.includes("vivomoney-hml")
		||	host.includes("vivomoney-dev")
		||	window.location.host.includes("localhost")
			? "development"
			: "production";

	const baseUrl = urlsBFF[bff][environment];
	return baseUrl;
};
